export default __webpack_public_path__ + "static/media/tfg_mainlogo.77b2935c.svg";